<template>
  <div id="review" v-if="showComponents">
    <div v-for="(v, i) in dataSource" :key="i">
      <title-background :title="v.title"></title-background>
      <el-form
        :disabled="disabledForm"
        label-position="top"
        :ref="v.ref"
        :rules="formRules[v.rules]"
        :model="formData"
      >
        <template v-for="(item, index) in v.content">
          <el-form-item
            v-if="item.type === 'radio' && !item.notDisplaying"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :style="item.bottomType ? 'margin-bottom: 0;' : ''"
            :class="item.width ? 'entireLength' : ''"
          >
            <el-radio-group
              v-model="formData[item.prop]"
              @input="handleRadioInput(item.prop)"
            >
              <el-radio
                v-for="(item2, index2) in item.children"
                :key="index2"
                :label="item2.value"
                >{{ item2.name }}</el-radio
              >
            </el-radio-group>
            <br
              v-if="
                item.bottomType === 'tips' || item.bottomType === 'download'
              "
            />
            <p v-if="item.bottomType === 'tips'" :style="item.bottomStyle">
              {{ item.bottomTips }}
            </p>
            <p
              v-if="item.bottomType === 'download'"
              :class="item.bottomType === 'download' ? 'review-download' : ''"
              :style="item.bottomStyle"
              @click="downloadFile"
            >
              <i class="el-icon-download"></i>
              {{ item.bottomTips }}
            </p>
          </el-form-item>
          <el-form-item
            v-if="item.type === 'checkbox' && !item.notDisplaying"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :class="item.width && item.width === '100%' ? 'entireLength' : ''"
          >
            <el-checkbox-group v-model="formData[item.prop]">
              <el-checkbox
                v-for="(item3, index3) in item.children"
                :key="index3"
                :label="item3.value"
                border
              ></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
            v-if="item.type === 'empty'"
            :key="index"
            :prop="item.prop"
            :class="item.width && item.width === '10%' ? 'quarter' : ''"
          >
          </el-form-item>
          <el-form-item
            v-if="item.type === 'text' && !item.notDisplaying"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :class="item.width && item.width === '10%' ? 'quarter' : ''"
          >
            <el-input
              :placeholder="item.placeholder ? item.placeholder : ''"
              v-model="formData[item.prop]"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="item.type === 'textarea' && !item.notDisplaying"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :class="item.width ? 'entireLength' : ''"
          >
            <el-input
              type="textarea"
              :placeholder="item.placeholder"
              v-model="formData[item.prop]"
              :rows="4"
              :maxlength="item.max_length"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="item.type === 'select' && !item.notDisplaying"
            :key="index"
            :prop="item.prop"
            :label="item.label"
          >
            <el-select
              v-model="formData[item.prop]"
              placeholder="请选择"
              @change="(val) => handleSelectChange(val, item.prop)"
            >
              <el-option
                v-for="item4 in item.children"
                :key="item4.value"
                :label="item4.name"
                :value="item4.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="item.type === 'cascader' && !item.notDisplaying"
            :key="index"
            :prop="item.prop"
            :label="item.label"
          >
            <el-cascader
              v-model="formData[item.prop]"
              :options="item.options"
              :props="{ value: 'id', label: 'value' }"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item
            v-if="item.type === 'interval' && !item.notDisplaying"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            class="review-interval"
          >
            <span v-for="(item5, index5) in item.children" :key="index5">
              <span>{{ item5.textInFront }}</span>
              <el-input
                v-model="formData[item5.prop]"
                v-if="item5.type === 'text'"
              ></el-input>
              {{ item5.text }}
            </span>
          </el-form-item>
          <el-form-item
            v-if="item.type === 'variable' && !item.notDisplaying"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :class="['review-variable', item.width ? 'entireLength' : '']"
            :style="
              item.background ? `background-color: ${item.background}` : ''
            "
          >
            <div
              v-for="(item6, index6) in formData[item.prop]"
              :key="index6"
              class="review-variable-wrapper"
            >
              <el-input v-model="formData[item.prop][index6]"></el-input>
              <img
                class="review-variable-icon"
                :src="index6 == 0 ? plusIcon : minusIcon"
                @click="
                  handleChangeAddressCount(
                    item.prop,
                    index6 == 0 ? 'plus' : 'minus',
                    index6
                  )
                "
                alt=""
              />
            </div>
          </el-form-item>
          <el-form-item
            v-if="
              item.type === 'upload' &&
              showComponents === true &&
              !item.notDisplaying
            "
            :key="index"
            :prop="item.prop"
            :label="item.label"
          >
            <upload-file
              @uploadSuccess="handleUploadResult"
              :parentRef="v.ref"
              :prop="item.prop"
              :file="formData[item.prop]"
              :validation="item.uploadFormatValidation"
              :tips="item.tips"
              :uploadType="item.uploadType"
            ></upload-file>
          </el-form-item>
          <el-form-item
            v-if="
              item.type === 'flexible' &&
              item.children.length !== 0 &&
              !item.notDisplaying
            "
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :class="[
              'review-flexible',
              item.width && item.width === '100%' ? 'entireLength' : '',
            ]"
          >
            <div v-for="(item7, index7) in item.children" :key="index7">
              <span>{{ item7.label }}：</span>
              <el-select
                v-model="formData[item7.prop][index7].id"
                placeholder="请选择"
              >
                <el-option
                  v-for="item8 in item7.options"
                  :key="item8.id"
                  :label="item8.name"
                  :value="item8.id"
                >
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            class="textAndUpload"
            v-if="item.type === 'textAndUpload' && !item.notDisplaying"
            :key="index"
            :prop="item.prop"
            :label="item.label"
          >
            <el-input
              :placeholder="item.placeholder ? item.placeholder : ''"
              v-model="formData[item.prop].name"
            ></el-input>
            <upload-file
              @uploadSuccess="handleUploadResult"
              :parentRef="v.ref"
              :prop="item.prop"
              :file="formData[item.prop].url"
              :validation="item.uploadFormatValidation"
              :tips="item.tips"
              :uploadType="item.uploadType"
            ></upload-file>
          </el-form-item>
          <div v-if="item.type === 'title'" :key="index" class="review-title">
            <div></div>
            <p>{{ item.name }}</p>
          </div>
        </template>
      </el-form>
    </div>
    <div class="review-button">
      <div
        v-if="this.status == 0 || this.status == 10"
        class="border"
        @click="handleDataFormat('save')"
      >
        保存
      </div>
      <div
        v-if="this.status == 0 || this.status == 10"
        class="fill"
        @click="verifyForm"
      >
        下一步
      </div>
      <div
        v-if="
          (this.status == 1 || this.status == 2 || this.status == -1) &&
          this.step != 5
        "
        class="fill"
        style="margin: 0 !important"
        @click="toNextPage"
      >
        下一页
      </div>
    </div>
  </div>
</template>

<script>
import titleBackground from "./json/titleBackground.vue";
import uploadFile from "./json/uploadFile.vue";
import { setData } from "./json/formData";
import { getDataReview, saveDataReview, submitDataReview } from "../../api/api";
export default {
  // 当这个值为-1时，代表着是查看表单，不影响其他状态; 当这个值为10的时候，代表审核未通过（9），重新提交审核（10）
  props: ["status", "step"],
  components: {
    titleBackground,
    uploadFile,
  },
  data() {
    return {
      disabledForm: false,
      pageState: -1,
      rowData: {},
      formData: [],
      dataSource: [],
      formRules: {},
      plusIcon: require("../../assets/plus.jpg"),
      minusIcon: require("../../assets/minus.jpg"),
      loading: true,
      showComponents: false,
      fileDownloadAddress: "",
      declareId: null,
    };
  },
  async created() {
    let obj = await setData();
    this.formData = obj.data;
    this.rowData = obj.data;
    this.dataSource = obj.dataSource;
    this.formRules = obj.dataValidation;
    this.fileDownloadAddress = JSON.parse(
      localStorage.getItem("theSession")
    ).award_introduction;
    this.declareId = JSON.parse(localStorage.getItem("theSession")).id;
    this.getDataReviewData();
  },
  methods: {
    async getDataReviewData() {
      const res = await getDataReview(`declare_items_id=${this.declareId}`);
      this.initData(res.data);
    },
    initData(data) {
      if (Object.keys(data).length !== 0) {
        this.formData = data;
        this.rowData.designer_card_type = data.designer_card_type; // 和下面的代码其实干了一件事
        this.formRules.businessRules.business_price_interval[0].data = data; // formdata.js，这两个字段的验证器合二为一了，在回显的时候，需要把最新的数据给过去，作为触发验证的数据源
        this.formRules.valueAddRules.service_price_interval[0].data = data; // formdata.js，这两个字段的验证器合二为一了，在回显的时候，需要把最新的数据给过去，作为触发验证的数据源
        this.handleRadioInput("awards_join_evaluation");
        this.handleRadioInput("service_exhibition");
        let education = this.formData.education;
        // 教育经历是新加的，所以部分已填报过的用户，返回的教育经历数据为[]，做一下初始化处理
        if (Array.isArray(education) && education.length == 0) {
          this.$set(this.formData, "zhuanke_education", {
            name: "",
            url: "",
          });
          this.$set(this.formData, "benke_education", {
            name: "",
            url: "",
          });
          this.$set(this.formData, "yanjiusheng_education", {
            name: "",
            url: "",
          });
          this.$set(this.formData, "boshi_education", {
            name: "",
            url: "",
          });
          this.$set(this.formData, "boshihou_education", {
            name: "",
            url: "",
          });
        } else {
          this.$set(
            this.formData,
            "zhuanke_education",
            education.zhuanke_education
          );
          this.$set(
            this.formData,
            "benke_education",
            education.benke_education
          );
          this.$set(
            this.formData,
            "yanjiusheng_education",
            education.yanjiusheng_education
          );
          this.$set(
            this.formData,
            "boshi_education",
            education.boshi_education
          );
          this.$set(
            this.formData,
            "boshihou_education",
            education.boshihou_education
          );
        }
      }
      if (this.status == 1 || this.status == 2 || this.status == -1) {
        this.disabledForm = true;
      }
      this.showComponents = true;
    },
    handleChangeAddressCount(prop, operate, index) {
      if (operate === "plus") {
        this.formData[prop].push("");
      } else if (operate === "minus") {
        this.formData[prop].splice(index, 1);
      }
    },
    handleSelectChange(val, prop) {
      if (prop === "designer_card_type") {
        this.formData.designer_ID_number = "";
        this.rowData.designer_card_type = val;
        this.$refs.brand[0].validateField("designer_ID_number");
      }
    },
    handleRadioInput(e) {
      if (e === "service_exhibition") {
        if (this.formData[e] == "1") {
          this.dataSource[7].content[3].notDisplaying = false;
          this.dataSource[7].content[4].notDisplaying = false;
        } else if (this.formData[e] == "0") {
          this.dataSource[7].content[3].notDisplaying = true;
          this.dataSource[7].content[4].notDisplaying = true;
        }
      } else if (e === "awards_join_evaluation") {
        if (this.formData[e] == "1") {
          this.dataSource[6].content.forEach((item, index) => {
            item.notDisplaying = false;
          });
          this.dataSource[6].content[0].notDisplaying = false;
        } else if (this.formData[e] == "0") {
          this.dataSource[6].content.forEach((item, index) => {
            item.notDisplaying = true;
          });
          this.dataSource[6].content[0].notDisplaying = false;
        }
      }
    },
    downloadFile() {
      let downloadURL = this.fileDownloadAddress;
      fetch(downloadURL).then((res) => {
        res.blob().then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob);
          const filename = "奖项介绍下载";
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        });
      });
    },
    handleUploadResult(data) {
      if (data.isIDcard) {
        if (data.idcardSurface === "front") {
          this.formData[data.prop][0] = data.address;
        } else if (data.idcardSurface === "theback") {
          this.formData[data.prop][1] = data.address;
        }
      } else {
        if (data.parentRef === "education") {
          this.formData[data.prop].url = data.address;
        } else {
          this.formData[data.prop] = data.address;
        }
      }
      this.$refs[data.parentRef][0].validateField(data.prop);
    },
    verifyForm() {
      let refNameArray = [];
      this.dataSource.forEach((item) => {
        refNameArray.push(item.ref);
      });
      let arr = [];
      refNameArray.forEach((item) => {
        arr.push(this.checkForm(item));
      });
      Promise.all(arr)
        .then(() => {
          this.handleDataFormat("submit");
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    checkForm(formName) {
      return new Promise((resolve, reject) => {
        this.$refs[formName][0].validate((valid, field) => {
          if (valid) {
            resolve();
          } else {
            let firstFailField = Object.keys(field)[0];
            let firstFailFieldMessage = field[firstFailField][0].message;
            reject(firstFailFieldMessage);
          }
        });
      });
    },
    async handleDataFormat(flag) {
      if (this.status != 0 && this.status != 10) {
        this.$message.error("请勿重复提交");
        return false;
      }
      let data = this.formData;
      data.declare_items_id = this.declareId;
      data.education = {
        zhuanke_education: data.zhuanke_education,
        benke_education: data.benke_education,
        yanjiusheng_education: data.yanjiusheng_education,
        boshi_education: data.boshi_education,
        boshihou_education: data.boshihou_education,
      };
      if (flag === "save") {
        const res = await saveDataReview(data);
        if (res.code == 1) {
          this.$message.success("保存成功");
          location.reload();
        } else {
          this.$message.error(res.msg);
        }
      } else if (flag === "submit") {
        this.$confirm("请问您是否准确的填写了以上资料?", "提交确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          const res = await submitDataReview(data);
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "已完成提交",
            });
            location.reload();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    toNextPage() {
      this.$parent.changeSteps(this.$parent.busactive + 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  justify-content: space-between;
  padding: 0 3%;
  .el-form-item {
    width: 30%;
    /deep/ .el-form-item__label {
      line-height: 24px;
    }
    /deep/ .el-radio__label {
      font-size: 14px;
    }
    /deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #e40080;
    }
    /deep/ .el-checkbox__input:hover .el-checkbox__inner {
      border-color: #e40080;
    }
    /deep/ .el-checkbox.is-bordered.is-checked {
      border-color: #e40080;
    }
    .el-cascader {
      width: 100%;
    }
  }
  .el-form-item.entireLength {
    width: 100% !important;
  }
  .el-form-item.quarter {
    width: 12% !important;
  }
  .review-download {
    cursor: pointer;
    width: auto;
    font-weight: 700;
    display: inline-block;
  }
  .review-interval {
    .el-form-item__content {
      display: flex;
      .el-input {
        width: 20%;
      }
    }
  }
  .review-variable {
    box-sizing: border-box;
    padding: 16px;
    /deep/ .el-form-item__content {
      display: flex;
      flex-wrap: wrap;
      .review-variable-wrapper {
        width: 25%;
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .el-input {
          width: 80%;
        }
        .review-variable-icon {
          width: 28px;
          height: 28px;
          cursor: pointer;
          margin-left: 10px;
        }
      }
    }
  }
  .review-flexible {
    /deep/ .el-form-item__content {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      > div {
        width: 30%;
        margin-right: 3.33%;
        display: flex;
        align-items: center;
        margin-top: 20px;
        > span {
          min-width: 100px;
        }
        > .el-select {
          min-width: 100px;
          flex: 1;
        }
      }
    }
  }
  .review-title {
    width: 100%;
    div {
      width: 100%;
      height: 1px;
      background: #f3f3f3;
      margin-bottom: 20px;
    }
    p {
      color: #333;
      font-weight: 700;
      margin-bottom: 12px;
    }
  }
  .textAndUpload {
    /deep/ .el-input {
      margin-bottom: 10px;
    }
  }
}
.review-button {
  margin-top: 50px;
  display: flex;
  justify-content: center;
  > div {
    width: 126px;
    height: 42px;
    border-radius: 9px;
    box-sizing: border-box;
    line-height: 42px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
  }
  > div.border {
    border: 1px solid #e40080;
    background: #fff;
    color: #e40080;
    margin-right: 10px;
  }
  > div.fill {
    background: #e40080;
    color: #fff;
    margin-left: 10px;
    border: none;
  }
}
</style>